import { useEffect } from 'react';

interface Props {
  condition?: boolean;
}

/**
 * This hook should be used when u want to prompt the user with an `Unsaved Changes` dialog before Page-Leave
 */
export const useUnloadListener = (props?: Props) => {
  let condition = props?.condition;
  if (condition === undefined) {
    condition = true;
  }
  useEffect(() => {
    if (!condition) return;
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [condition]);
};
